import { Button, Tooltip } from "@fluentui/react-components";
import { FC, ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { Clipboard16Regular, Checkmark16Filled } from '@fluentui/react-icons';
import './TableSection.scss';

interface TableSectionProps {
    children: string | number | boolean | ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null;
    className?: string;
}

// manages the table returned as answer
const TableSection: FC<TableSectionProps> = ({ children }) => {
    const tableContainerRef = useRef<HTMLDivElement>(null);
    const [copied, setCopied] = useState<boolean>(false);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
    }, [copied]);

    const onCopy = useCallback(() => {
        if (tableContainerRef.current !== null) {
            const clipboardItem = new ClipboardItem({
                "text/plain": new Blob(
                    [tableContainerRef.current.innerText],
                    { type: "text/plain" }
                ),
                "text/html": new Blob(
                    [tableContainerRef.current.outerHTML],
                    { type: "text/html" }
                ),
            });

            navigator.clipboard.write([clipboardItem]);
            setCopied(true);
        }
    }, [tableContainerRef]);

    return <div ref={tableContainerRef} className='tableContainer' onMouseOver={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        {
            hovered && 
            <div className='tableDivCopyButton'>
                <Tooltip content={'Copy table'} relationship="label">
                    <Button
                        className='tableCopyButton'
                        size='medium'
                        icon={copied ? <Checkmark16Filled /> : <Clipboard16Regular />}
                        appearance='transparent'
                        shape='circular'
                        onClick={onCopy}
                    />
                </Tooltip>
            </div>
        }
        <div>
            <table className='table'>
                {children}
            </table>
        </div>
        
    </div>;
}

export default TableSection;
